var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.sorting)?_c('div',[(_vm.direction === 'desc')?_c('icon',{attrs:{"width":"12","height":"12","type":"arrow-up","path":"arrows"}}):_vm._e(),(_vm.direction === 'asc')?_c('icon',{attrs:{"width":"12","height":"12","type":"arrow-down","path":"arrows"}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }